import { useState } from 'react'
import { useAdminWaitlist } from '../../hooks/useAdmin'

function formatDate(iso: string) {
  return new Date(iso).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}

export default function AdminWaitlistPage() {
  const [page, setPage] = useState(1)
  const { data, isLoading } = useAdminWaitlist(page)

  const entries = data?.data ?? []
  const total = data?.meta.total ?? 0
  const totalPages = Math.ceil(total / 30)

  return (
    <div>
      <div className="mb-6">
        <h1 className="m-0 text-[24px] font-bold">Waitlist</h1>
        <p className="text-[13px] text-muted mt-2 m-0 max-w-[560px] leading-[1.5]">
          Emails collected from the coming-soon page before launch.
        </p>
        <div className="text-[13px] text-muted mt-1">{total} signups</div>
      </div>

      {isLoading ? (
        <div className="text-muted text-[14px] py-10">Loading…</div>
      ) : entries.length === 0 ? (
        <div className="text-muted text-[14px] py-10">No waitlist signups yet.</div>
      ) : (
        <div className="bg-surface rounded-[14px] border border-line-soft overflow-hidden">
          <table className="w-full border-collapse text-[13px]">
            <thead>
              <tr className="border-b border-line-soft bg-s2">
                {['Email', 'Signed up'].map((h) => (
                  <th key={h} className="px-4 py-2.5 text-left font-semibold text-ink-2 text-[12px]">
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {entries.map((entry, i) => (
                <tr key={entry.id} className={i < entries.length - 1 ? 'border-b border-line-soft' : ''}>
                  <td className="px-4 py-3 font-medium">{entry.email}</td>
                  <td className="px-4 py-3 text-muted">{formatDate(entry.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {totalPages > 1 && (
        <div className="flex gap-2 mt-5 justify-end">
          <button type="button" onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={page === 1} className="px-3 py-1.5 rounded-lg border border-line-soft bg-surface text-ink text-[13px] cursor-pointer font-sans disabled:opacity-40">← Prev</button>
          <span className="text-[13px] text-muted self-center">Page {page} of {totalPages}</span>
          <button type="button" onClick={() => setPage((p) => Math.min(totalPages, p + 1))} disabled={page === totalPages} className="px-3 py-1.5 rounded-lg border border-line-soft bg-surface text-ink text-[13px] cursor-pointer font-sans disabled:opacity-40">Next →</button>
        </div>
      )}
    </div>
  )
}
